import { classNamesFunction, getTheme, Stack } from '@fluentui/react';
import React from 'react';
import { getStyles } from '../LandingPage.styles';
import { IReportLandingPageStyleProps, IReportLandingPageStyles } from '../LandingPage.types';

export const SectionLayout = ({ Icon, title, description }) => {
  const getClassNames = classNamesFunction<IReportLandingPageStyleProps, IReportLandingPageStyles>();
  const classNames = getClassNames(getStyles, { theme: getTheme() });

  return (
    <Stack tokens={{ childrenGap: 8 }} className={classNames.sectionStyle} horizontalAlign="center">
      <Stack.Item>
        <Icon />
      </Stack.Item>
      <Stack.Item>
        <div className={classNames.sectionTitle}>{title}</div>
      </Stack.Item>
      <Stack.Item>
        <div className={classNames.sectionDescription}>{description}</div>
      </Stack.Item>
    </Stack>
  );
};
